import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { LanguagesService } from 'app/components/languages/languages.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalYesNoComponent } from '../modal-yes-no/modal-yes-no.component';
import { ModalSimpleComponent } from '../modal-simple/modal-simple.component';
import { ExhitorsService } from '../exhitors/exhitors.service';
import { ProductsService } from '../products/products.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-translated-fields',
  templateUrl: './translated-fields.component.html',
  styleUrls: ['./translated-fields.component.css']
})
export class TranslatedFieldsComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  @Output() defaultLangValid = new EventEmitter<boolean>();

  @Input() exhibitorData: object = {
    product: {},
    exhibitor: {}
  };
  @Input() hasName: boolean = false;
  @Input() type: string = 'product';
  @Input() eventName: string = '';
  @Input() selectedOds: Array<any> = [];
  languages: Array<any> = [];
  activeTab: number = 0;
  defaultLanguage: string = '';
  hasDescription: boolean = false;
  exhibitorId;
  frontendLink;
  disabled: boolean = false;

  count: any = {
    es_ES: 0,
    ca_ES: 0,
    en_GB: 0,
  };
  productId;
  catalogueId;

  constructor(private sessionService: SessionService, public catalogueService: CatalogueService, private languagesService: LanguagesService,
    private modalService: NgbModal, private exhitorsService: ExhitorsService, private productsService:ProductsService, private router:Router
  ,private activatedRoute: ActivatedRoute) {
      this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
      this.frontendLink = this.catalogueService.getProperty('id') + this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/edit';
      this.productId = this.activatedRoute.snapshot.paramMap.get('productId') || null;
      this.catalogueId = JSON.parse(this.sessionService.get('catalogId', false));
     }

  setTab(tab) {
    this.activeTab = tab;
  }

  initTranslations() {

    this.exhibitorData[this.type]['translations'] = [];

    for (let i = 0; i < this.languages.length; i++) {

      let lang = {
        description: '',
        name: '',
        language: this.translateLang(this.languages[i])
      }

      this.exhibitorData[this.type]['translations'].push(lang);

    }
  }

  translateLang(lang) {

    switch(lang) {
      case 'es':
        return 'es_ES';
        break;
      case 'ca':
        return 'ca_ES';
        break;
      case 'en':
        return 'en_GB';
        break;
      default:
        return false;
        break;
    }

  }

  checkTranslation(translation: any): void {
    if (translation && translation.description && translation.description.trim()) {
      this.hasDescription = true;
    } else {
      this.hasDescription = false;
    }
  }



  hidesTranslation(translation) {

    let activeLang = this.languages[this.activeTab];
    let language = this.translateLang(activeLang);

    if (language === translation.language) {
        this.checkTranslation(translation);
      return false;
    } else {
      return true;
    }

  }

  getCatalogueDefaultLanguages(getCatalogueDefaultLanguagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.languagesService.getCatalogueDefaultLanguages(getCatalogueDefaultLanguagesIn)
      .subscribe((data: object) => {
        this.getCatalogueDefaultLanguagesOk(data);
      },
        error => {
          this.getCatalogueDefaultLanguagesError(error);
        });

  }

  getCatalogueDefaultLanguagesOk(data) {

    this.loader.count--;
    this.defaultLanguage = data;
    this.setTabByDefaultLanguage();

    /** Fixes recently created product translations */
    setTimeout(() => {
      this.exhibitorData[this.type]['translations'] = this.exhibitorData[this.type]['translations'] || [];
      if (this.exhibitorData[this.type]['translations'].length < 1) {
        this.initTranslations();
      } else {
        this.checkDefaultLang();
      }
    }, 1000);
  }

  getCatalogueDefaultLanguagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  setTabByDefaultLanguage() {

    for (let i = 0; i < this.languages.length; i++) {

      let lang = this.translateLang(this.languages[i]);

      if (lang === this.defaultLanguage) {
        this.setTab(i);
      }

    }

  }

  defaultLanguageIsEmpty() {

    let isEmpty = true;
    this.exhibitorData[this.type]['translations'] = this.exhibitorData[this.type]['translations'] || [];

    for (let i = 0; i < this.exhibitorData[this.type]['translations'].length; i++) {

      let lang = this.exhibitorData[this.type]['translations'][i];

      if (lang['language'] === this.defaultLanguage && lang['description']) {
        isEmpty = false;
      }

    }
    return isEmpty;

  }

  getTranslations(description: string, name: string) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    const modalRef = this.modalService.open(ModalYesNoComponent);
    modalRef.componentInstance.question = 'MODAL_YES_NO.IA_TRANSLATION';

    modalRef.result.then( (option) => {

      if (option === 'yes') {

        let dataIn = {
          texts: [
            {
              "id":1,
              "text": description,
              "textType": "description"
            }
          ],
          languageFrom: this.languages[this.activeTab],
          languageTo: this.languages,
          apiVersion: "",
          apiKey: ""
        }
        if(name) {
          dataIn.texts.push({"id":2, "text": name, "textType": "name"})
        }

        let exhibitorId;

        if(this.type === 'exhibitor') {
          exhibitorId = this.exhibitorData['exhibitorId'];
        } else {
          exhibitorId = this.exhibitorData[this.type]['embeddedExhibitorId']
        }

        let suffix = '';
        if (this.type === 'exhibitor') {
          suffix = '-EXHIBITOR';
        } else {
          let pId = this.exhibitorData[this.type]['id'] || this.productId;
          suffix = '-PRODUCT-' + pId;
        }

        let redisData = {
          redisKey: this.eventName + '-' + parseInt(exhibitorId) + suffix
        }
        this.catalogueService.getTranslations(dataIn, redisData.redisKey).subscribe((data: object) => {
          this.getTranslationsOk(data);
        },
          error => {
            this.getTranslationsError(error);
          });

      } else {
        this.loader.count--;
      }

    }).catch((reason) => {
      // Handle modal dismissal (click outside, ESC, etc.)
      this.loader.count--; // Optionally reset loader if canceled
      console.log('Modal closed or dismissed:', reason);
    });;
  }

  getTranslationsOk(data) {

    this.loader.count--;
    this.exhibitorData[this.type]['translations'] = [];

    const translationsMap = {};

    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].extendedTextResponses.length; j++) {
        const response = data[i].extendedTextResponses[j];
        const langCode = response.to;
        const translatedLang = this.translateLang(langCode);

        // If language entry doesn't exist yet, create it
        if (!translationsMap[langCode]) {
          translationsMap[langCode] = {
            description: '',
            name: '',
            language: translatedLang
          };
        }

        // Assign based on textType
        if (response.textType === 'description') {
          translationsMap[langCode].description = response.text;
        } else if (response.textType === 'name') {
          translationsMap[langCode].name = response.text;
        }
      }
    }

    Object.values(translationsMap).forEach(translation => {
      this.exhibitorData[this.type]['translations'].push(translation);
    });


    this.saveModifications();
  }

  getTranslationsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  saveExhibitor(saveExhibitorIn) {

    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.saveExhibitor(saveExhibitorIn)
      .subscribe((data: object) => {
        this.saveExhibitorOk(data);
      },
        error => {
          this.saveExhibitorError(error);
        });

  }

  saveExhibitorOk(data) {
    this.loader.count--;
    this.reloadPage();
  }

  saveExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    if (this.exhitorsService.isHierarchicalPropertyLimitError(error)) {
      alertData.alertMessage = 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ERRORS.HIERARCHICAL_PROPERTY_LIMIT';
      const modalRef = this.modalService.open(ModalSimpleComponent);
      modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
      modalRef.componentInstance.modalInformation = alertData.alertMessage;
      modalRef.componentInstance.isHtml = false;
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
  }

  saveModifications() {
    this.loader.count++;
    if(this.type === 'exhibitor') {
      let saveExhibitorIn = this.exhibitorData['exhibitor'];
      saveExhibitorIn.descriptionTranslation = this.getDescriptionTranslations();
      saveExhibitorIn.exhibitorODS = this.selectedOds;
      saveExhibitorIn.eventName = this.eventName;
      saveExhibitorIn.properties = this.exhibitorData['exhibitor']['propertiesArray'];
      saveExhibitorIn.hierarchicalProperties = this.exhibitorData['selectedCategories'];
      saveExhibitorIn.masterProperties = [];

      // Remove unwanted properties:
      delete saveExhibitorIn.exhibitorStatusItem;
      delete saveExhibitorIn.cataloguePlansArray;
      delete saveExhibitorIn.cataloguePlan;
      delete saveExhibitorIn.sector;
      delete saveExhibitorIn.hierarchicalPropertiesArray;
      delete saveExhibitorIn.propertiesArray;
      delete saveExhibitorIn.sponsoredHierarchicalPropertiesArray;
      delete saveExhibitorIn.propertiesTree;
      delete saveExhibitorIn.masterProperties;
      delete saveExhibitorIn.translations;
      delete saveExhibitorIn._links;

      this.saveExhibitor(saveExhibitorIn);

    } else {
      this.saveProductTranslations();
    }



  }

  saveProductTranslations() {

    let saveProductIn = {
      descriptionTranslations: this.getTranslationsByProperty('description'),
      eventName: this.eventName,
      exhibitorId: parseInt(this.exhibitorData[this.type]['embeddedExhibitorId']),
      hierarchicalProperties: [],
      nameTranslations: this.getTranslationsByProperty('name'),
      properties: [],
      publicationOrder: this.exhibitorData['product']['publicationOrder'],
      videoUrl: this.exhibitorData['product']['videoUrl']
    }

    if (this.exhibitorData[this.type]['id']) {
      saveProductIn['id'] = this.exhibitorData[this.type]['id'];
    } else {
      saveProductIn['published'] = false;
    }

    this.saveProduct(saveProductIn);

  }

  saveProduct(saveProductIn) {

    this.alertType = '';
    this.alertMessage = '';

    this.productsService.saveProduct(saveProductIn)
      .subscribe((data: object) => {
        this.saveProductOk(data);
      },
        error => {
          this.saveProductError(error);
        });

  }

  saveProductOk(data) {

    this.loader.count--;

      let editLink = this.catalogueService.getProperty('id') + '/' + this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorData[this.type]['embeddedExhibitorId'] + '/products/' + data['id'] + '/product-detail-edit';
      this.router.navigate([editLink]);
    }


  saveProductError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getTranslationsByProperty(property) {

    let translations = {};
    this.exhibitorData['product']['translations'] = this.exhibitorData['product']['translations'] || [];

    for(let i = 0; i < this.exhibitorData['product']['translations'].length; i++) {
      let translation = this.exhibitorData['product']['translations'][i];
      translations[translation['language']] = translation[property];
    }

    return translations;
  }

  getDescriptionTranslations(): Record<string, string> {
    const translationsArray = this.exhibitorData?.[this.type]?.translations ?? [];
    const translations: Record<string, string> = {};

    for (const t of translationsArray) {
      if (t && t.language) {
        translations[t.language] = t.description ?? '';
      }
    }

    return translations;

  }

  reloadPage() {
    window.location.reload();
  }

  checkDefaultLang() {
    const defaultTranslation = this.exhibitorData[this.type].translations.find(t => t.language === this.defaultLanguage);

    const isValid = defaultTranslation
      && defaultTranslation.name?.trim() !== ''
      && defaultTranslation.description?.trim() !== '';

    this.defaultLangValid.emit(isValid);
  }

  ngOnInit() {

    if(this.type === 'product') {
      this.disabled = this.productId ? false : true;
    }

    this.languages = JSON.parse(this.sessionService.get('availableLanguages', false));

    let catalogIdRecovered = this.catalogueService.getProperty('id');

    let getCatalogueDefaultLanguagesIn = catalogIdRecovered ? catalogIdRecovered : this.catalogueId

    this.getCatalogueDefaultLanguages(getCatalogueDefaultLanguagesIn);

  }

}
